import React from "react";

const Footer = () => {
  return (
    <div className="position-sticky top-100 pt-4 mt-5 bg-dark text-white">
      <div className="row row-cols-1 row-cols-md-3 w-100">
        <div className="col text-center mb-2">
          <h5 className="text-warning pb-1 pb-md-3">Contact</h5>
          <p>
            <i className="fas fa-home me-2"></i>XXXXXX, Kathmandu <br />{" "}
            XXXXXXXX
          </p>
          <p>
            <i className="fas fa-phone me-2"></i>01XXXXXXX, 98XXXXXXXX
          </p>
        </div>
        <div className="col text-center mb-2">
          <h5 className="text-warning pb-1 pb-md-3">Working</h5>
          <p>
            <i className="fas fa-clock me-2"></i>Hours: 7:00 AM - 8:00 PM
          </p>
          <p>
            <i className="fas fa-calendar me-2"></i>Days: Sunday - Saturday
          </p>
        </div>
        <div className="col text-center mb-2">
          <h5 className="text-warning pb-1 pb-md-3">Social Media</h5>
          <a href="https://www.facebook.com" target="_blank">
            <i className="h3 me-4 text-info fa-brands fa-facebook"></i>
          </a>
          <a href="https://twitter.com" target="_blank">
            <i className="h3 me-4 fa-brands fa-twitter"></i>
          </a>
          <a href="https://youtube.com" target="_blank">
            <i className="h3 text-danger fa-brands fa-youtube"></i>
          </a>
        </div>
      </div>
      <hr className="m-1" />
      <h6 className="text-center pb-2 m-0">&copy; 2023. Avinna Maharjan. All rights reserved.</h6>
    </div>
  );
};

export default Footer;
